import { genericRequiredFieldError } from '../../../../../../../constants';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import ApplicantFiledTaxReturnsInThePastRuleset from '../../business/ruleset/ApplicantFiledTaxReturnsInThePastRuleset';
import { taxDocuments } from '../../form_models/loanFormModel';

const { applicantFiledTaxReturnsInThePast } = taxDocuments;

export class ApplicantFiledTaxReturnsInThePastValidation
  implements ValidationSchema
{
  public name = applicantFiledTaxReturnsInThePast.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: genericRequiredFieldError,
    value: true,
  };
  public nullable = true;
  public ruleset = ApplicantFiledTaxReturnsInThePastRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const schema = args[this.dependsOn.length];
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required(genericRequiredFieldError);
    return schema.notRequired();
  }
}
export default new Validation(
  new ApplicantFiledTaxReturnsInThePastValidation()
);
